import { cn } from "../../lib/utils";
import type { OrderStatus } from "./types";

export const ORDER_STATUS_LABEL: Record<OrderStatus, string> = {
  payment_pending: "Payment pending",
  payment_successful: "Payment successful",
  payment_failed: "Payment failed",
  cancelled: "Cancelled",
  partially_refunded: "Partially refunded",
  refunded: "Refunded",
};

const TONE: Record<OrderStatus, string> = {
  payment_pending: "border-warning/30 bg-warning-soft text-warning",
  payment_successful: "border-success/30 bg-success-soft text-success",
  payment_failed: "border-danger/30 bg-danger-soft text-danger",
  cancelled: "border-line bg-soft text-ink-3",
  partially_refunded: "border-info/30 bg-info-soft text-info",
  refunded: "border-line bg-soft text-ink-2",
};

export function OrderStatusBadge({ status }: { status: OrderStatus }) {
  return (
    <span className={cn("inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold", TONE[status])}>
      {ORDER_STATUS_LABEL[status]}
    </span>
  );
}
